<template>
    <div class="footer">
        <!--<div class="copyright">-->
        <!--版权所有©上海市信息网络安全管理协会 沪ICP备18022661号-1-->
        <!--</div>-->
        <div class="wrap">
            <Row>
                <i-col :md="12">
                    <div>主办单位：{{page.subject}}</div>
                    <div>版权所有
                        <a class="url" href="https://beian.miit.gov.cn/" target="_blank">
                        {{page.icpCode.split('及')[0]}}
                        </a>
                        及{{page.icpCode.split('及')[1]}}
                    </div>
                </i-col>
                <i-col :md="12">
                    <div style="text-align: right">
                        <div>地址：{{page.address}}&nbsp;&nbsp;&nbsp;&nbsp;邮编：{{page.postCode}}</div>
                        <div>所有内容未经授权不得转载</div>
                    </div>
                </i-col>
            </Row>
        </div>
    </div>
</template>
<style lang="less" scoped>
@import "../../common/mui";

.footer {
    background-color: @color-main;
    min-height: 70px;

    & * {
        color: white;
    }

    & .wrap {
        max-width: @page-max-width;
        margin: 0 auto;
        color: white;
        padding: 10px 8px;
    }
}

.url:hover {
    color: #F0C284;
}
</style>
<script>
import {mapGetters} from 'vuex'

export default {
    name: 'v-footer',
    data() {
        return {}
    },
    computed: {
        ...mapGetters('home', ['page'])
    },
    components: {}
}
</script>
